<template>
  <div class="panel">
    <div
      v-if="title"
      class="header"
      @click="expandOnClick()">
      <div class="title-area">
        <div class="title-inline">
          <h3>{{ title }}</h3>
          <span v-if="$slots['title-inline']" @click.stop>
            <slot name="title-inline" />
          </span>
        </div>
        <span v-if="$slots['title-bottom']" @click.stop>
          <slot name="title-bottom" />
        </span>
      </div>

      <div class="actions">
        <span @click.stop>
          <slot name="actions" @click.stop />
        </span>

        <el-button
          v-if="collapsable"
          class="ml-10"
          size="medium"
          :icon="expanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          circle />
      </div>
    </div>

    <el-collapse-transition>
      <div v-show="!collapsable || expanded">
        <div v-if="$slots.default" class="content" :class="!!maxHeight && 'scrollable'" :style="{ maxHeight: maxHeight ? `${maxHeight}px` : null }">
          <slot />
        </div>

        <div
          v-if="$slots.footer"
          class="footer">
          <slot name="footer" />
        </div>
      </div>
    </el-collapse-transition>

    <div v-if="loader" class="loader">
      <loader :size="45" color="#fff" />
    </div>
  </div>
</template>

<script>
import Loader from '../other/Loader.vue'
export default {
  components: { Loader },
  props: {
    title: {
      type: String,
      default: null
    },

    collapsable: {
      type: Boolean,
      default: false
    },

    initiallyExpanded: {
      type: Boolean,
      default: false
    },

    loader: {
      type: Boolean,
      default: false
    },

    maxHeight: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      expanded: this.initiallyExpanded
    }
  },

  methods: {
    expandOnClick () {
      if (this.collapsable) {
        this.expanded = !this.expanded
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .panel {
    width: 100%;
    background-color: #fff;
    border-radius: 15px;
    box-sizing: border-box;
    box-shadow: rgba(100, 100, 111, 0.1) 0px 7px 29px 0px;
    overflow: hidden;
    position: relative;
    .loader {
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.7);
    }
    .header {
      width: 100%;
      padding: 20px 30px;
      box-sizing: border-box;
      border-bottom: 1px solid $border;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      h3 {
        font-size: 14px;
        color: $dark;
        letter-spacing: 0.5px;
        margin: 0px;
      }
      .title-area {
        display: inline-flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
      }
      .title-inline {
        display: inline-flex;
        align-items: center;
        gap: 14px;
      }
      .actions {
        display: flex;
      }
    }
    .content {
      width: 100%;
      padding: 20px 30px 20px 30px;
      box-sizing: border-box;
      overflow-x: auto;
      &.scrollable {
        overflow-y: auto;
      }
    }
    .footer {
      width: 100%;
      padding: 20px 30px;
      box-sizing: border-box;
      border-top: 1px solid $border;
    }
  }

  .panel + .panel {
    margin-top: 20px;
  }

  .theme-dark {
    .panel {
      background-color: $darker;
      .header {
        border-color: rgba(255, 255, 255, 0.1);
        h3 {
          color: #fff;
        }
      }
    }
  }

  .panel + .panel {
    margin-top: 20px;
  }

  .ml-10 {
    margin-left: 10px;
  }

  @media (max-width: 991px) {
    .panel {
      .header {
        flex-direction: column;
        .actions {
          margin-top: 15px;
          display: flex;
        }
      }
    }
  }
</style>
